import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { API_BASE } from '../services/api';

const fmt = (n) => '$' + Number(n || 0).toLocaleString('es-CO');
const fdate = (d) => d ? new Date(d).toLocaleDateString('es-CO') : '—';

export default function EstadoCuentaPublica() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [err, setErr] = useState('');

  useEffect(() => {
    fetch(`${API_BASE}/api/estado-cuenta/${token}`)
      .then(r => r.ok ? r.json() : Promise.reject())
      .then(setData)
      .catch(() => setErr('No pudimos cargar el estado de cuenta. El enlace puede haber expirado.'));
  }, [token]);

  if (err) return <div style={s.wrap}><div style={s.card}><p style={{ color: '#b91c1c' }}>{err}</p></div></div>;
  if (!data) return <div style={s.wrap}><div style={s.card}><p style={{ color: '#64748b' }}>Cargando…</p></div></div>;

  const hoy = new Date();
  const dias = (v) => v ? Math.floor((hoy - new Date(v)) / 86400000) : null;

  return (
    <div style={s.wrap}>
      <div style={s.card}>
        <div style={s.head}>
          <div>
            {data.empresa.logo_url && <img src={`${API_BASE}${data.empresa.logo_url}`} alt="" style={{ maxHeight: 54, marginBottom: 6 }} />}
            <h1 style={s.emp}>{data.empresa.nombre}</h1>
            <p style={s.sub}>NIT {data.empresa.nit}{data.empresa.telefono ? ` · Tel ${data.empresa.telefono}` : ''}</p>
            {data.empresa.email && <p style={s.sub}>{data.empresa.email}</p>}
          </div>
          <div style={{ textAlign: 'right' }}>
            <div style={s.badge}>ESTADO DE CUENTA</div>
            <p style={s.sub}>Corte: {fdate(data.corte)}</p>
          </div>
        </div>

        <p style={{ fontSize: 15, margin: '4px 0 18px' }}><strong>Cliente:</strong> {data.cliente.razon_social}{data.cliente.nit ? ` — NIT ${data.cliente.nit}` : ''}</p>

        <div style={{ overflowX: 'auto' }}>
          <table style={s.table}>
            <thead>
              <tr>{['Factura', 'Emisión', 'Vencimiento', 'Estado', 'Total', 'Saldo'].map(h => <th key={h} style={s.th}>{h}</th>)}</tr>
            </thead>
            <tbody>
              {data.facturas.length === 0 && <tr><td colSpan={6} style={{ ...s.td, textAlign: 'center', color: '#64748b' }}>No tiene facturas pendientes. ¡Gracias!</td></tr>}
              {data.facturas.map((f, i) => {
                const dv = dias(f.fecha_vencimiento);
                return (
                  <tr key={i}>
                    <td style={s.td}>{f.numero}</td>
                    <td style={s.td}>{fdate(f.fecha_emision)}</td>
                    <td style={s.td}>{fdate(f.fecha_vencimiento)}</td>
                    <td style={{ ...s.td, textAlign: 'center' }}>{dv != null && dv > 0 ? <span style={{ color: '#dc2626', fontWeight: 600 }}>Vencida {dv} d</span> : (dv != null ? `En ${Math.abs(dv)} d` : '—')}</td>
                    <td style={{ ...s.td, textAlign: 'right' }}>{fmt(f.total)}</td>
                    <td style={{ ...s.td, textAlign: 'right', fontWeight: 700 }}>{fmt(f.saldo)}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        <div style={s.totalRow}>Saldo total pendiente: <strong style={s.totalVal}>{fmt(data.total)}</strong></div>

        <div style={{ textAlign: 'center', marginTop: 22 }}>
          <a href={`${API_BASE}/api/estado-cuenta/${token}/pdf`} target="_blank" rel="noreferrer" style={s.btn}>⬇ Descargar PDF</a>
        </div>
      </div>
    </div>
  );
}

const s = {
  wrap: { minHeight: '100vh', background: '#f1f5f9', padding: '24px 12px', display: 'flex', justifyContent: 'center', fontFamily: 'system-ui,Arial,sans-serif' },
  card: { background: '#fff', width: '100%', maxWidth: 820, borderRadius: 14, boxShadow: '0 8px 30px rgba(0,0,0,.08)', padding: 28, color: '#1e293b' },
  head: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', borderBottom: '2px solid #1e293b', paddingBottom: 14, marginBottom: 16, gap: 12, flexWrap: 'wrap' },
  emp: { fontSize: 20, margin: '0 0 2px' },
  sub: { color: '#64748b', fontSize: 12, margin: 0 },
  badge: { background: '#fffbeb', color: '#b45309', border: '1px solid #f59e0b', borderRadius: 8, padding: '4px 10px', fontWeight: 700, fontSize: 13, display: 'inline-block' },
  table: { width: '100%', borderCollapse: 'collapse', fontSize: 13 },
  th: { background: '#f1f5f9', textAlign: 'left', padding: '9px 8px', fontSize: 11, textTransform: 'uppercase', color: '#475569', borderBottom: '1px solid #e2e8f0' },
  td: { padding: '9px 8px', borderBottom: '1px solid #eef2f7' },
  totalRow: { marginTop: 16, textAlign: 'right', fontSize: 15 },
  totalVal: { fontSize: 22, color: '#b45309', marginLeft: 8 },
  btn: { background: '#25D366', color: '#053b23', fontWeight: 700, textDecoration: 'none', padding: '12px 22px', borderRadius: 10, fontSize: 15, display: 'inline-block' },
};
